export default "__VITE_ASSET__BIpLDCi1__"